import axios from "axios";
import { useEffect, useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";

import HTMLEditor from "components/UI/HTMLEditor";
import { useAuth } from "hooks/useAuth";

export default function AddQAUpdateModal({
  show,
  handleClose,
  qa,
  editQaUpdate,
  setAlert,
  testMock, //to be used in test
}) {
  const [qaUpdate, setQaUpdate] = useState({});
  const [overviewValid, setOverviewValid] = useState(true);
  const [enforceFocusModal, setEnforceFocusModal] = useState(true);
  const { authToken, csrfToken, currentUser } = useAuth();

  useEffect(() => {
    setQaUpdate({});
  }, [show]);

  useEffect(() => {
    if (testMock) {
      setQaUpdate(testMock);
    }
  }, [show]);

  const handleChange = (e) => {
    setQaUpdate({ ...qaUpdate, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    const form = e.currentTarget;
    e.preventDefault();
    if (!editQaUpdate?.upid) {
      if (form.checkValidity() === false || !qaUpdate.note1) {
        e.stopPropagation();
        if (!qaUpdate.note1) {
          setOverviewValid(false);
        } else {
          setOverviewValid(true);
        }
      } else {
        axios
          .post(
            `${import.meta.env.VITE_DJANGO_ENDPOINT}question-answer/update/`,
            {
              ...qaUpdate,
              shared: false,
              rid: qa?.rid,
              creator: currentUser?.id,
              entrydate: new Date(
                new Date().setMinutes(
                  new Date().getMinutes() - new Date().getTimezoneOffset(),
                ),
              ),
            },
            {
              withCredentials: true,
              headers: {
                "X-CSRFToken": csrfToken,
                Authorization: `Token ${authToken}`,
              },
            },
          )
          .then(() => {
            handleClose();
            if (setAlert) {
              setAlert({
                message: "Successfully added QA update!",
                type: "success",
              });
            }
          })
          .catch((error) => {
            console.log("error sending email: " + error);
            handleClose();
            if (setAlert) {
              setAlert({ message: "Error adding QA update.", type: "danger" });
            }
          });
      }
    } else {
      axios
        .put(
          `${import.meta.env.VITE_DJANGO_ENDPOINT}question-answer/update/${editQaUpdate?.upid}/`,
          {
            shared: false,
            note1: editQaUpdate.note1,
            rid: editQaUpdate?.rid__rid,
            ...qaUpdate,
          },
          {
            withCredentials: true,
            headers: {
              "X-CSRFToken": csrfToken,
              Authorization: `Token ${authToken}`,
            },
          },
        )
        .then((response) => {
          handleClose();
          setAlert({
            message: "Successfully updated QA update!",
            type: "success",
          });
        })
        .catch((error) => {
          console.log("error sending email: " + error);
          handleClose();
          setAlert({ message: "Error updating QA Update.", type: "danger" });
        });
    }
  };

  return (
    <Modal
      size="lg"
      show={show}
      onHide={handleClose}
      enforceFocus={enforceFocusModal}
    >
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <h2>+ QA UPDATE for {qa?.ticket}</h2>
        </Modal.Header>
        <Modal.Body>
          <Form.Label className="fw-bold">
            Submitter: {currentUser?.first_name} {currentUser?.last_name}
          </Form.Label>
          <Form.Group className="mb-3" controlId="note1">
            <Form.Label className="fw-bold">Overview:*</Form.Label>
            <HTMLEditor
              name="note1"
              handleChange={handleChange}
              setIsValid={setOverviewValid}
              isValid={overviewValid}
              defaultValue={editQaUpdate?.note1}
              setEnforceFocusModal={setEnforceFocusModal}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" type="reset" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" type="submit">
            {editQaUpdate?.upid ? "Update" : "Add"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
